import { Box } from "@mui/material";
import { ContractDocumentRow, ContractDocumentTableModel } from "../ContractDocuments.types.ts";
import { put } from "../../../../../common/api/apiShared.ts";
import { DotLegalInfoDialog, useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../../../../localization/useTranslation.ts";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

export interface ToggleDocumentAsMainDialogProps {
    contractId: string;
    currentMainDocumentId: string | undefined;
    document: ContractDocumentRow;

    onCloseDialog: () => void;
    onDocumentToggledAsMainDocument: () => void;
}

function ToggleDocumentAsMainDialog(props: ToggleDocumentAsMainDialogProps) {
    const snackbar = useDotLegalSnackbar();
    const isMainDocument = props.currentMainDocumentId === props.document.contractDocumentId;

    const { translateString } = useTranslation();

    const toggleDocumentIsMainDocumentMutation = useDotLegalMutation(getToggleDocumentIsMainDocumentMutation);
    const toggleDocumentIsMainDocument = () => {
        toggleDocumentIsMainDocumentMutation.mutateAsync(props.document.contractDocumentId, {
            onSuccess: (resp: any) => {
                if (isMainDocument) {
                    snackbar.show(translateString("documentRemovedAsMainDocument", { name: props.document.name }));
                } else {
                    snackbar.show(translateString("documentMarkedAsMainDocument", { name: props.document.name }));
                }

                props.onDocumentToggledAsMainDocument();
            },
        });
    };

    function getToggleDocumentIsMainDocumentMutation(documentId: string) {
        return put(`/contract/${props.contractId}/toggle-as-main-document/${documentId}`, null);
    }

    return (
        <DotLegalInfoDialog
            header={isMainDocument ? translateString("removeAsMainDocument") : translateString("setAsMainDocument")}
            btnText={isMainDocument ? translateString("remove") : translateString("save")}
            content={
                isMainDocument
                    ? translateString("confirmRemoveDocumentAsMainDocument", { name: props.document.name })
                    : translateString("confirmSetAsDocumentAsMainDocument", { name: props.document.name })
            }
            onCloseDialog={props.onCloseDialog}
            onBtnClick={toggleDocumentIsMainDocument}
        />
    );
}

export default ToggleDocumentAsMainDialog;
